module.exports = __webpack_public_path__ + "img/btn-login-top.4b616e58.png";